import { FC } from "react";
import KickImage from 'Reuseables/KickImage';

//Components
import CustomBody from "../CustomBody/index";
import { CustomButton } from "../../../Forms";

//Assets
import Rejected from "../../../../images/rejected.png";

//Interface
import { WrapperAndComponentInterface } from "./definitions";

const RequestCancelled: FC<WrapperAndComponentInterface> = ({
  canceled
}) => {
  return (
    <CustomBody>
      <div className="canceled-result">
        <KickImage src={Rejected} alt="rejected" className="rejected-icon" />
        <p className="title">Pick-up Cancelled</p>
        <p className="info">
          Your request has been cancelled. You can redo
          <br />
          this whole process on your seller dashboard.
        </p>

        <CustomButton
          text="OK"
          disabled={false}
          onClick={() => canceled()}
        />
      </div>
    </CustomBody>
  )
}
RequestCancelled.defaultProps = {
  canceled: () => { }
}

export default RequestCancelled;